import apiClient, { API_ENDPOINTS } from "@/config/api";

/**
 * 学习报告API服务
 */
class LearningReportAPI {
  /**
   * 获取学习报告数据
   * @returns {Promise} API响应
   */
  static async getLearningReport(params = {}) {
    try {
      console.log('学习报告API: 开始请求数据...');
      console.log('API端点:', API_ENDPOINTS.LEARNING_REPORT.GET_REPORT);
      console.log('请求参数:', params);
      console.log('apiClient:', apiClient);
      
      const response = await apiClient.post(API_ENDPOINTS.LEARNING_REPORT.GET_REPORT, params);
      console.log('学习报告API: 原始响应:', response);
      
      return {
        success: true,
        data: response.data || response,
        message: "获取学习报告成功",
      };
    } catch (error) {
      console.error("学习报告API: 请求失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "获取学习报告失败",
      };
    }
  }
}

export default LearningReportAPI;
